/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

interface Props {
	goBack: () => void;
}

const ReconMediaDetailHeader: React.FC<Props> = ({ goBack }) => {
	const { t } = useTranslation();
	return (
		<div className="bg-white border-b border-slate-200 px-8 py-4 shrink-0 shadow-sm">
			<div className="flex justify-between items-center">
				<div className="flex items-center gap-6">
					<button
						className="w-10 h-10 rounded-xl border border-slate-200 flex items-center justify-center text-slate-400 hover:text-orange-500 hover:bg-orange-50 transition-all"
						onClick={() => goBack()}
					>
						<span className="material-symbols-outlined text-xl">
							arrow_back
						</span>
					</button>
					<div className="flex items-center gap-10">
						<h2 className="text-xl font-black text-[#2D3E50] tracking-tight">
							{t('mediaReconcile.mediaBatch.finalBatchReconciliation')}
						</h2>
						<div className="flex items-center gap-3">
							<div className="w-7 h-7 rounded-full bg-emerald-500 text-white flex items-center justify-center">
								<span className="material-symbols-outlined text-xs font-black">
									check
								</span>
							</div>
							<div className="w-7 h-7 rounded-full bg-emerald-500 text-white flex items-center justify-center">
								<span className="material-symbols-outlined text-xs font-black">
									check
								</span>
							</div>
							<div className="w-7 h-7 rounded-full bg-emerald-500 text-white flex items-center justify-center">
								<span className="material-symbols-outlined text-xs font-black">
									check
								</span>
							</div>
							<div className="w-7 h-7 rounded-full bg-[#2D3E50] text-white flex items-center justify-center text-[10px] font-black ring-4 ring-slate-100">
								4
							</div>

							<div className="ml-6 flex flex-col">
								<span className="text-[7px] font-black text-orange-500 uppercase tracking-[0.2em] leading-none">
									{t('mediaReconcile.mediaBatch.activePhase')}
								</span>
								<span className="text-[9px] font-black text-[#2D3E50] uppercase tracking-wider">
									{t('mediaReconcile.mediaBatch.inventoryAccountingAndVarianceAudit')}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ReconMediaDetailHeader;
